export default __webpack_public_path__ + "static/media/brand2.23ae342f.svg";